"use client";

import React, { useEffect, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import { cn } from "@/lib/utils";
import { usePathname } from "next/navigation";

import { LinkButtonSimple } from "@/components/ui/button-simple";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [pastHero, setPastHero] = useState(false);
  const pathname = usePathname();
  const isHome = pathname === "/";

  useEffect(() => {
    const handleScroll = () => {
      // Check if scrolled past 64px for minimal header
      if (window.scrollY > 64) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }

      // Only check hero section on home page
      if (isHome) {
        const heroSection = document.getElementById("landing-hero");
        const header = document.querySelector("header");
        if (heroSection && header) {
          const headerHeight = header.offsetHeight;
          const heroBottom = heroSection.offsetTop + heroSection.offsetHeight - headerHeight;
          setPastHero(window.scrollY > heroBottom);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isHome]);

  return (
    <header
      className={cn(
        "fixed left-1/2 z-20 w-full -translate-x-1/2 transform transition-all duration-300",
        isHome ? (pastHero ? "bg-white" : "bg-system-obsidian") : "bg-white",
        scrolled ? "py-3 md:py-4" : "py-4 md:py-6",
        scrolled &&
          !pastHero &&
          isHome &&
          "bg-opacity-75 backdrop-blur-[15px] backdrop-saturate-[180%]"
      )}
    >
      <div className="landing-container">
        <div className="flex items-center justify-between">
          <Link
            href="/"
            className={cn(
              "relative transition-all duration-300",
              scrolled
                ? "h-[20.4px] w-[94.35px] sm:h-[22.1px] sm:w-[100.3px] md:h-[28.9px] md:w-[131.75px]"
                : "h-[24px] w-[111px] sm:h-[26px] sm:w-[118px] md:h-[34px] md:w-[155px]"
            )}
          >
            <Image
              src={!isHome || pastHero ? "/logo-black.svg" : "/logo-white.svg"}
              alt="logo"
              fill
              className="object-contain"
              priority
            />
          </Link>

          <nav className="flex items-center justify-between gap-3 md:gap-6">
            <LinkButtonSimple href="#join-waitlist" className={"h-[32px] md:h-[30px]"}>
              Join now
            </LinkButtonSimple>
            {/* <LangaugeDropDown variant="white" /> */}
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
